// extracted by mini-css-extract-plugin
export default {"cardsList":"EpicGroupCardsList_cardsList__tYzS0","cardsListTitle":"EpicGroupCardsList_cardsListTitle__qli2c","quantityOfItems":"EpicGroupCardsList_quantityOfItems__5b1UY"};